<template>
  <div class="bgfield" aria-hidden="true">
    <div class="bgfield__photo"></div>
    <div class="bgfield__overlay"></div>
    <div class="bgfield__grain"></div>
  </div>
</template>

<style scoped>
/* Fully static, eternal cover bg. No parallax — no moving photo edges. */
.bgfield {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
  background: var(--bg);
}
.bgfield__photo {
  position: absolute;
  inset: 0;
  background-image: url('/hero-panorama.jpg');
  background-size: cover;
  background-position: center 35%;
  background-repeat: no-repeat;
}
.bgfield__overlay {
  position: absolute;
  inset: 0;
  background: var(--hero-overlay);
}
.bgfield__grain {
  position: absolute;
  inset: 0;
  opacity: 0.16;
  mix-blend-mode: overlay;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='320' height='320'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.95  0 0 0 0 0.92  0 0 0 0 0.85  0 0 0 0.85 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>");
  background-size: 320px 320px;
}
</style>
